import React from 'react';
import { motion } from 'motion/react';
import { Phone } from 'lucide-react';
import OfficeLocationsSection from './OfficeLocationsSection';
import { Link } from 'react-router-dom';

// const services = [
//   'Digital Marketing',
//   'Web Development',
//   'Mobile App Development',
//   'AI Development',
//   'IT Consulting & Strategy',
//   'E-Commerce Development',
//   'UI/UX Development',
//   'Hire Dedicated Teams',
//   'Amazon Services',
//   'Other',
// ];

// const contactInfo = [
//   {
//     icon: MapPin,
//     title: 'Office Address',
//     details: ['Vadodara', 'Gujarat, India'],
//     // You may use inline style or custom CSS for gradient backgrounds
//     gradientBg: 'bg-gradient-primary', 
//   },
//   {
//     icon: Phone,
//     title: 'Phone Numbers',
//     details: ['+1 (555) 123‑4567', '+1 (555) 987‑6543'],
//     gradientBg: 'bg-gradient-success',
//   },
//   {
//     icon: Mail,
//     title: 'Email Address',
//     details: ['hello@softwareco.com', 'support@softwareco.com'],
//     gradientBg: 'bg-gradient-info',
//   },
//   {
//     icon: Clock,
//     title: 'Business Hours',
//     details: ['Mon ‑ Fri: 9:00 AM ‑ 6:00 PM', 'Sat: 10:00 AM ‑ 4:00 PM'],
//     gradientBg: 'bg-gradient-warning',
//   },
// ];

export default function ContactPage() {
  // const [formData, setFormData] = useState({
  //   name: '',
  //   email: '',
  //   phone: '',
  //   company: '',
  //   service: '',
  //   budget: '',
  //   message: '',
  // });
  // const [isSubmitting, setIsSubmitting] = useState(false);

  // const handleInputChange = (field, value) => {
  //   setFormData(prev => ({ ...prev, [field]: value }));
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);

  //   // simulate submission
  //   await new Promise(res => setTimeout(res, 2000));

  //   alert("Message sent successfully! We'll get back to you within 24 hours.");

  //   setFormData({
  //     name: '',
  //     email: '',
  //     phone: '',
  //     company: '',
  //     service: '',
  //     budget: '',
  //     message: '',
  //   });
  //   setIsSubmitting(false);
  // };

  return (
    <div className="min-vh-100 d-flex flex-column">

      {/* Hero Section */}
      <section className="position-relative overflow-hidden py-5" style={{ background: 'linear-gradient(to bottom right, #ebf8ff, #f3e8ff)' }}>
        {/* Decor circles/blur animations */}
        {[...Array(4)].map((_, i) => (
          <motion.div
            key={i}
            className="position-absolute rounded-circle"
            style={{
              width: '256px', height: '256px',
              background: 'rgba(147, 197, 253, 0.2)', // approximate blue-400/10
              filter: 'blur(48px)', // blur-3xl
              left: `${20 + i * 25}%`,
              top: `${10 + i * 20}%`,
            }}
            animate={{
              x: [0, 100, 0],
              y: [0, -50, 0],
              scale: [1, 1.1, 1],
            }}
            transition={{
              duration: 15 + i * 2,
              repeat: Infinity,
              repeatType: 'reverse',
            }}
          />
        ))}

        <div className="container position-relative text-center py-5">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mx-auto"
            style={{ maxWidth: '768px' }}
          >
            <span className="badge bg-primary text-light mb-3">Get In Touch</span>
            <h1 className="display-5 fw-bold mb-4 gradient-text" style={{ WebkitBackgroundClip: 'text', color: 'transparent' }}>
              Let’s Build Something Amazing Together
            </h1>
            <p className="lead text-muted fw-500 mb-5">
              Ready to transform your business with cutting‑edge technology? We’d love to hear about your project and discuss how we can help you achieve your goals.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Information */}
      <OfficeLocationsSection />

      {/* Contact Form & Map */}
      {/* <section className="py-5" style={{ background: 'linear-gradient(to bottom right, #f8fafc, #ebf8ff)' }}>
        <div className="container">
          <div className="row g-5 align-items-start">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="col-lg-6"
            >
              <div className="card shadow-lg border-0 rounded-4">
                <div className="card-body p-4 p-lg-5">
                  <h3 className="fw-bold mb-3" style={{ background: 'linear-gradient(to right, #1e3a8a, #7c3aed)', WebkitBackgroundClip: 'text', color: 'transparent' }}>
                    Send us a Message
                  </h3>
                  <p className="text-muted mb-4">
                    Fill out the form below and we'll get back to you within 24 hours.
                  </p>
                  <form onSubmit={handleSubmit} className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Full Name *</label>
                      <input
                        type="text"
                        className="form-control rounded-3 border-secondary"
                        required
                        value={formData.name}
                        onChange={e => handleInputChange('name', e.target.value)}
                        placeholder="John Doe"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Email Address *</label>
                      <input
                        type="email"
                        className="form-control rounded-3 border-secondary"
                        required
                        value={formData.email}
                        onChange={e => handleInputChange('email', e.target.value)}
                        placeholder="john@example.com"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="tel"
                        className="form-control rounded-3 border-secondary"
                        value={formData.phone}
                        onChange={e => handleInputChange('phone', e.target.value)}
                        placeholder="+1 (555) 123‑4567"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Company Name</label>
                      <input
                        type="text"
                        className="form-control rounded-3 border-secondary"
                        value={formData.company}
                        onChange={e => handleInputChange('company', e.target.value)}
                        placeholder="Your Company"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Service Interested In</label>
                      <select
                        className="form-select rounded-3 border-secondary"
                        value={formData.service}
                        onChange={e => handleInputChange('service', e.target.value)}
                      >
                        <option value="">Select a service</option>
                        {services.map(s => (
                          <option key={s} value={s}>{s}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Project Budget</label>
                      <select
                        className="form-select rounded-3 border-secondary"
                        value={formData.budget}
                        onChange={e => handleInputChange('budget', e.target.value)}
                      >
                        <option value="">Select budget range</option>
                        <option value="under‑10k">Under $10,000</option>
                        <option value="10k‑25k">$10,000‑$25,000</option>
                        <option value="25k‑50k">$25,000‑$50,000</option>
                        <option value="50k‑100k">$50,000‑$100,000</option>
                        <option value="over‑100k">Over $100,000</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Project Description *</label>
                      <textarea
                        className="form-control rounded-3 border-secondary"
                        rows={4}
                        required
                        value={formData.message}
                        onChange={e => handleInputChange('message', e.target.value)}
                        placeholder="Tell us about your project, goals, and requirements..."
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary w-100 rounded-3"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Sending Message...
                          </>
                        ) : (
                          <>
                            Send Message <Send size={20} className="ms-2" />
                          </>
                        )}
                      </button>
                      <p className="text-center small text-muted mt-2">
                        By submitting this form, you agree to our privacy policy and terms of service.
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="col-lg-6 d-flex flex-column gap-4"
            >
              <div className="card shadow-lg border-0 rounded-4 overflow-hidden mb-4">
                <div className="p-4 d-flex align-items-center justify-content-center" style={{ height: '256px', background: 'linear-gradient(to bottom right, #bfdbfe, #ddd6fe)' }}>
                  <MapPin size={48} className="text-primary mb-2" />
                  <div className="text-center">
                    <h5 className="fw-bold text-primary">Our Location</h5>
                    <p className="text-muted">Interactive map would be embedded here</p>
                  </div>
                </div>
              </div>

              <div className="card shadow border-0 rounded-4 mb-4">
                <div className="card-body">
                  <div className="d-flex align-items-start">
                    <CheckCircle size={32} className="text-success me-3 mt-1" />
                    <div>
                      <h5 className="fw-bold text-success mb-2">Quick Response Guarantee</h5>
                      <p className="text-muted">We typically respond to all inquiries within 2‑4 hours during business hours. For urgent matters, call us directly.</p>
                      <ul className="list-unstyled text-success">
                        <li>✓ Free initial consultation</li>
                        <li>✓ Detailed project proposal within 48 hours</li>
                        <li>✓ No obligation quote</li>
                        <li>✓ Expert technical guidance</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card shadow border-0 rounded-4">
                <div className="card-body">
                  <h5 className="fw-bold mb-3">Frequently Asked</h5>
                  <div className="mb-2">
                    <h6 className="fw-medium">How long does a typical project take?</h6>
                    <p className="text-muted small">Project timelines vary from 2‑6 months depending on complexity.</p>
                  </div>
                  <div className="mb-2">
                    <h6 className="fw-medium">Do you provide ongoing support?</h6>
                    <p className="text-muted small">Yes, we offer comprehensive maintenance and support packages.</p>
                  </div>
                  <div className="mb-2">
                    <h6 className="fw-medium">Can you work with our existing team?</h6>
                    <p className="text-muted small">Absolutely! We collaborate seamlessly with in‑house teams.</p>
                  </div>
                </div>
              </div>

            </motion.div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(to right, #2563eb, #7c3aed)' }}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mx-auto"
            style={{ maxWidth: '720px' }}
          >
            <h2 className="display-5 fw-bold mb-4">Prefer to Talk Directly?</h2>
            <p className="lead mb-4 fw-500" style={{ color: '#e0f2fe' }}>Sometimes a conversation is worth a thousand emails. Book a free consultation call with our experts.</p>
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <Link to={"tel:+91-6352118120"} className="btn btn-light btn-lg rounded-pill px-4 py-2">
                Call Now: (+91) 6352118120 <Phone size={20} className="ms-2" />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

    </div>
  );
}
